import React from "react";
import "./BrandInfo.scss";
import BrandSelector from "./BrandSelector";
import { CommonEnums } from "../../../../enums/common.enums";

const BrandInfo = ({ formik }: { formik: any }) => {
  const onClickAgencytype = (type: string) => {
    formik.setFieldValue("agency_type", type);
    formik.setFieldValue("brand_id", "");
    formik.setFieldValue("brand_name", "");
  };
  return (
    <div className="brand-info-container">
      <p className="brand-info-heading">Brand Info</p>
      <p className="brand-info-text">
        Are you Independent agency or associated with any brand or franchisee
        network?
      </p>
      <div
        className={`brand-info-btn ${
          formik?.values?.agency_type === CommonEnums?.agencyType?.independent
            ? "active-brand-info-btn"
            : ""
        }`}
        onClick={() => onClickAgencytype(CommonEnums?.agencyType?.independent)}
      >
        Independent Agency
      </div>
      <div
        className={`brand-info-btn ${
          formik?.values?.agency_type === CommonEnums?.agencyType?.brand
            ? "active-brand-info-btn"
            : ""
        }`}
        onClick={() => onClickAgencytype(CommonEnums?.agencyType?.brand)}
      >
        Brand/Franchisee
      </div>
      {formik?.values?.agency_type === CommonEnums?.agencyType?.brand && (
        <BrandSelector formik={formik} />
      )}
    </div>
  );
};

export default BrandInfo;
